import "./services.css";

import React from "react";
import { Helmet } from "react-helmet";

import { CONVEYANCING, NOTARY, DECEASED_ESTATE, ESTATE_PLANNING } from "../../data/services";
import Reveal from "../general/Reveal";
import ContactSection from "../home/ContactSection";
import TopicTabs from "./TopicTabs";

const Banner = ({ src, alt }) => (
  <div className={"service-banner"}>
    <img
      src={src}
      alt={alt}
      width={2200}
      height={1467}
      loading={"lazy"}
    />
  </div>
);

//Conveyancing & Notary: text on the left, the topics panel on the right
const SplitService = ({ service }) => (
  <React.Fragment>
    <Banner
      src={service.image}
      alt={service.imageAlt}
    />
    <section
      id={service.id}
      className={"service-split"}
    >
      <Reveal className={"service-split-text"}>
        <h2 className={"h-section"}>
          {service.title}
          {" "}
          <span className={"script"}>{service.scriptTitle}</span>
        </h2>
        {service.intro.map((p) => <p key={p}>{p}</p>)}
        {service.introList ? (
          <ul>
            {service.introList.map((item) => <li key={item}>{item}</li>)}
          </ul>
        ) : null}
      </Reveal>
      <TopicTabs
        id={service.id}
        topics={service.topics}
      />
    </section>
  </React.Fragment>
);

//Deceased estate & wills: centred on green
const GreenHeading = ({ service }) => (
  <h2 className={"h-section"}>
    {service.beforeScript}
    {" "}
    <span className={"script script-white"}>{service.scriptTitle}</span>
    {service.afterScript ? ` ${service.afterScript}` : ""}
  </h2>
);

const Services = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Services | Janine Botha Attorneys</title>
        <meta
          name={"description"}
          content={"Conveyancing & property law, notary services, deceased estate administration and wills in Centurion, Gauteng."}
        />
      </Helmet>

      <section className={"services-hero"}>
        <div className={"container services-hero-grid"}>
          <div>
            <h1 className={"script services-hero-title"}>Services</h1>
            <p className={"lead"}>
              Expertise You Can Trust.
              <br />
              Property, Estates &amp; Notarial Services—Handled with Care.
            </p>
          </div>
          <img
            className={"services-hero-bubbles"}
            src={"/images/bubbles.webp"}
            alt={""}
            width={900}
            height={969}
          />
        </div>
      </section>

      <SplitService service={CONVEYANCING} />
      <SplitService service={NOTARY} />

      <section
        id={DECEASED_ESTATE.id}
        className={"section bg-green service-green"}
      >
        <Reveal className={"container-narrow"}>
          <GreenHeading service={DECEASED_ESTATE} />
          {DECEASED_ESTATE.intro.map((p) => <p key={p}>{p}</p>)}
          <ol className={"estate-steps"}>
            {DECEASED_ESTATE.steps.map((step, i) => (
              <li key={step.title}>
                <span
                  className={"estate-step-num"}
                  aria-hidden={"true"}
                >
                  {i + 1}
                </span>
                <div>
                  <h3>{`Step ${i + 1}: ${step.title}`}</h3>
                  <p>{step.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </Reveal>
      </section>

      <Banner
        src={DECEASED_ESTATE.image}
        alt={DECEASED_ESTATE.imageAlt}
      />

      <section
        id={ESTATE_PLANNING.id}
        className={"section bg-green service-green"}
      >
        <Reveal className={"container-narrow"}>
          <GreenHeading service={ESTATE_PLANNING} />
          {ESTATE_PLANNING.intro.map((p) => <p key={p}>{p}</p>)}
        </Reveal>
      </section>

      {/* Same "Ready to Chat?" enquiry form as the home page. Divided from the green wills section above */}
      <ContactSection className={"contact-divided"} />
    </React.Fragment>
  );
};

export default Services;
